var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.713 17.788a.718.718 0 001.018 0 .726.726 0 000-1.023l-4.713-4.736 4.771-4.794a.726.726 0 000-1.023.718.718 0 00-1.018 0L12 11.006 7.23 6.212a.718.718 0 00-1.02 0 .726.726 0 000 1.023l4.772 4.794-4.713 4.736a.726.726 0 000 1.023.718.718 0 001.018 0L12 13.052l4.713 4.736z",
    fill: "#C4C4C4"
  })));
}
export default SvgClearSearch;